import styles from './styles.css';
import { FC, ReactNode } from 'react';
import { UIHeading2, UIHeading4, UIText1, UIText2, useDeviceType } from '@cian/ui-kit';

interface IBenefitItemProps {
  icon: ReactNode;
  title: string;
  description?: string;
}

export const BenefitItem: FC<IBenefitItemProps> = ({ title, icon, description }) => {
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';
  const Title = isDesktop ? UIHeading2 : UIHeading4;
  const Description = isDesktop ? UIText1 : UIText2;

  return (
    <div className={styles['benefit']}>
      <div className={styles['icon']}>{icon}</div>
      <div className={styles['details']}>
        <Title>{title}</Title>
        {description && <Description>{description}</Description>}
      </div>
    </div>
  );
};
